import * as process from 'process';

const config = {
  apiUrl: process.env.REACT_APP_BASE_URL
}

export default config;